import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const RESET_PATH = "/anbieter/passwort-zuruecksetzen";

// Der Recovery-Hash wird sehr früh erfasst, da der Supabase-Client ihn
// nach der Verarbeitung aus der URL entfernt.
const initialHash =
  typeof window !== "undefined" ? window.location.hash : "";

function hashIsRecovery(hash: string): boolean {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!raw) return false;
  const params = new URLSearchParams(raw);
  return (
    params.get("type") === "recovery" ||
    (!!params.get("error_code") && raw.includes("recovery"))
  );
}

/**
 * Leitet Passwort-Reset-Links auf die Reset-Seite um, auch wenn der
 * Mail-Link auf der Startseite landet.
 */
export function RecoveryRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === RESET_PATH) return;

    if (hashIsRecovery(initialHash) || hashIsRecovery(window.location.hash)) {
      navigate(RESET_PATH + (initialHash || window.location.hash), {
        replace: true,
      });
      return;
    }

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY") {
        navigate(RESET_PATH, { replace: true });
      }
    });

    return () => subscription.unsubscribe();
  }, [location.pathname, navigate]);

  return null;
}
